var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick with circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 8.00033C13.9998 11.314 11.3135 14.0003 7.99984 14.0003C4.68613 14.0003 1.99984 11.314 1.99984 8.00033C1.99984 4.68662 4.68613 2.00033 7.99984 2.00033C11.3135 2.00033 13.9998 4.68662 13.9998 8.00033ZM15.3332 8.00033C15.3332 12.0504 12.0499 15.3337 7.99984 15.3337C3.94975 15.3337 0.666504 12.0504 0.666504 8.00033C0.666504 3.95024 3.94975 0.666992 7.99984 0.666992C12.0499 0.666992 15.3332 3.95024 15.3332 8.00033ZM11.8349 5.77267C12.0774 5.49558 12.0493 5.0744 11.7722 4.83195C11.4951 4.5895 11.0739 4.61757 10.8315 4.89466L6.66651 9.65461L5.16823 7.94228C4.92578 7.66519 4.5046 7.63711 4.22751 7.87957C3.95042 8.12202 3.92234 8.5432 4.1648 8.82029L6.16479 11.106C6.29139 11.2507 6.47427 11.3337 6.66651 11.3337C6.85875 11.3337 7.04164 11.2507 7.16823 11.106L11.8349 5.77267Z",
    fill: "#D9A521"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplete);
export default __webpack_public_path__ + "static/media/ic_complete.b4642bce6a04684f59b494ea015bf546.svg";
export { ForwardRef as ReactComponent };